<template>
  <div v-if="show"
  class="overflow-y-auto bg-[#00000080] overflow-x-hidden fixed w-screen h-screen top-0 left-0 py-4 z-50 justify-center items-center tw-flex"
  aria-modal="true" role="dialog">
    <div class="relative rounded-bl-[8px] rounded-br-[8px]" style="width: 450px">
      <div class="rounded-tl-[16px] rounded-tr-[16px] bg-[#fff] p-[10px]">
        <div class="tw-flex items-center pb-[16px]  font-normal border-b border-[#296B2D]  gap-[14px]">
          <span class="font-bold text-18">
          </span>
        </div>
        <button @mousedown="close" type="button" data-modal-toggle="defaultModal" class="absolute right-[46px] top-[16px] cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="13.121" height="13.121" viewBox="0 0 13.121 13.121">
          <g id="Grupo_23802" data-name="Grupo 23802" transform="translate(-1096.439 -193.439)">
          <line id="Línea_1862" data-name="Línea 1862" x1="11" y2="11" transform="translate(1097.5 194.5)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.5"/>
          <line id="Línea_1863" data-name="Línea 1863" x2="11" y2="11" transform="translate(1097.5 194.5)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.5"/>
          </g>
          </svg>
        </button>
      </div>
      <div class="bg-[#fff] rounded-bl-[16px] rounded-br-[16px] body">
        <div class="px-[16px] tw-flex flex-col items-center justify-center">

        <p class="text-14 font-semibold"><translate>Would you like to remove this prompt?</translate></p>
          <svg xmlns="http://www.w3.org/2000/svg" width="21.939" height="20.349" viewBox="0 0 21.939 20.349">
            <path id="Trazado_5628" data-name="Trazado 5628" d="M12.489-52.614v-2.323a.39.39,0,0,0-.116-.287.376.376,0,0,0-.275-.116H9.75a.376.376,0,0,0-.275.116.39.39,0,0,0-.116.287v2.323a.39.39,0,0,0,.116.287.376.376,0,0,0,.275.116H12.1a.376.376,0,0,0,.275-.116A.39.39,0,0,0,12.489-52.614Zm-.024-4.574.22-5.613a.269.269,0,0,0-.122-.232.473.473,0,0,0-.293-.135H9.578a.473.473,0,0,0-.293.135.293.293,0,0,0-.122.257l.208,5.588a.235.235,0,0,0,.122.2.527.527,0,0,0,.293.079h2.262a.5.5,0,0,0,.287-.079A.272.272,0,0,0,12.464-57.188Zm-.171-11.422,9.392,17.218a1.459,1.459,0,0,1-.024,1.541,1.537,1.537,0,0,1-.569.563,1.529,1.529,0,0,1-.777.208H1.532a1.529,1.529,0,0,1-.777-.208,1.537,1.537,0,0,1-.569-.563,1.459,1.459,0,0,1-.024-1.541L9.554-68.609a1.562,1.562,0,0,1,.575-.6,1.517,1.517,0,0,1,.795-.22,1.517,1.517,0,0,1,.795.22A1.562,1.562,0,0,1,12.293-68.609Z" transform="translate(0.046 69.429)" fill="#ff9800"/>
          </svg>

          <p class="text-12 text-center"><translate>The deletion and editing of prompts will be applied to the analysis in the next scheduled update.</translate></p>

          <div class="buttons">
            <button @click="close()" class="cancel"><translate>Cancel</translate></button>

            <button @click="confirm()" class="confirm"><translate>Acept</translate></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MixinIAReputation from "@/mixins/iareputation.js"

export default {
  mixins: [MixinIAReputation],
    props: {
      show: {
        default: false
      }
    },
  data() {
    return {
      active: 'openai'
    }
  },
  computed: {

  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    confirm() {
      this.$emit('onConfirmDelete', true)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
#headModalExcededLimit {
    background-color: #DBE1E1;
}
.body{
  padding: 59px 0;
}
.close-modal {
    position: absolute;
    top: 15px;
    right: 15px;
}

.icoWarning {
    margin-bottom: -70px;
}

.boxInfo {
    color: #4D4F5C;
    font-size: 1rem;
}
.buttons{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 40px;
  button{
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    border-radius: 18px;
    padding: 14px 24px;
    &.cancel{
      background-color: #D5D5D5;
    }
    &.confirm{
      background-color: #1B1A1C;
    }
  }
}
</style>
